<template>
  <div class="container">
    <div class="login">
      <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
      <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
      <button class="button" @click="loginWithFacebook()">{{$t('login.facebook')}}</button>
      <button class="button" @click="loginWithGoogle()">{{$t('login.google')}}</button>
      <button class="button button--ios" v-if="isAppIOS" @click="loginWithIOS()">
        <img src="@/assets/appleid_button@2x.png" alt="">{{$t('login.ios')}}
      </button>
      <router-link to="/login/mail">
        <button class="button">{{$t('login.mail')}}</button>
      </router-link>
      <img src="@/assets/logo.svg" alt="" class="login__logo-footer" v-if="$config.MODE == 'SUPERLIGA'">
    </div>
  </div>
</template>

<script>
import PersistentData from '@/plugins/persistentData'

export default {
  computed: {
    isAppIOS: function() {
      return window["cordova"] != undefined && window["device"] && window["device"].platform.toLowerCase() == 'ios'
    }
  },
  methods: {
    async profileGet() {
      const profile = await this.$store.dispatch("profileGet")
      if (profile.data.birthDate == null && profile.data.team == null) {
        this.$router.push('/login/onboarding')
      } else {
        this.$router.push('/home/games')
      }
    },
    loginWithFacebook() {
      const self = this
      if (window["cordova"] != undefined) {
        window.facebookConnectPlugin.login(['email'], fbRes => {
          self.$store.dispatch('authenticateFacebook' , {
            accessToken: fbRes.authResponse.accessToken,
            registrationKey: ''
          }).then(request => {
            PersistentData.setData('fullName', `${request.data.firstName} ${request.data.lastName}`)
            PersistentData.setData('token', request.data.token)
            PersistentData.setData('tokenExpiration', request.data.tokenExpiration)
            self.profileGet()
          })
          
        })
      }
      else
      {
        const window_facebook = window.open(`https://www.facebook.com/v2.11/dialog/oauth?&response_type=token&display=popup&client_id=${process.env.VUE_APP_FACEBOOK_CLIENT_ID}&display=popup&redirect_uri=${process.env.VUE_APP_FACEBOOK_REDIRECT_URL}/redirect_login&scope=email`,null,'width=600,height=400');
        const self = this
        var loop = setInterval(function() {   
          if(window_facebook.closed) {
            clearInterval(loop);
            self.profileGet()      
          }
        }, 500);
      }
    },
    showNotificationLoginGoogle() {
      this.$store.dispatch("addNotification", {
        value: this.$t('notifications.loginGoogle'),
        status: 'success',
        remove: true
      })
    },
    showNotificationLoginApple() {
      this.$store.dispatch("addNotification", {
        value: this.$t('notifications.loginApple'),
        status: 'success',
        remove: true
      })
    },
    authenticateGoogle(accessToken) {
      const self = this
      self.$store.dispatch('authenticateGoogle' , {
        IdToken: accessToken,
        RegistrationKey: ''
      }).then((authRes) => {
        PersistentData.setData('fullName', `${authRes.data.firstName} ${authRes.data.lastName}`)
        PersistentData.setData('token', authRes.data.token)
        PersistentData.setData('tokenExpiration', authRes.data.tokenExpiration)
        self.profileGet()
      })
    },
    loginWithGoogle() {
      const self = this
      if (window["cordova"] != undefined) {
        window.plugins.googleplus.login({
          webClientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          scope: 'profile email openid',
          prompt: 'select_account'
        }, 
        function(loginRes){
          self.showNotificationLoginGoogle()
          self.authenticateGoogle(loginRes.idToken)
        })
      } else {
        this.$gAuth.signIn()
          .then(authCode => {
            this.showNotificationLoginGoogle()
            const authResponse = authCode.getAuthResponse()
            self.authenticateGoogle(authResponse.id_token)
          })
          .catch(() => {
            this.$store.dispatch("addNotification", {
              value: this.$t('notifications.failedLoginGoogle'),
              status: 'danger',
              remove: true
            })
          })
      }
    },
    loginWithIOS() {
      const self = this
      window["cordova"].plugins.SignInWithApple
        .signin({ requestedScopes: [0,1] }, 
          async function(res){ 
            const params = {
              userId: res.user,
              firstName: res.fullName.givenName,
              lastName: res.fullName.familyName,
              token: res.identityToken
            }
            self.showNotificationLoginApple()
            const request = await self.$store.dispatch('authenticateApple', params)
            self.$store.dispatch('removeNotification', 0)
            if (request && request.status == 200) {
              PersistentData.setData('fullName', `${request.data.firstName} ${request.data.lastName}`)
              PersistentData.setData('token', request.data.token)
              PersistentData.setData('tokenExpiration', request.data.tokenExpiration)
              if (request.data.askForEmail) {
                self.$router.push(`/login/IOS`)
              } else {
                self.profileGet()
              }
            }
          },
          function(error) { 
            console.log('error',error) 
          }
        );
    }
  }
}
</script>

<style lang="scss">

</style>